<template>
  <svg fill="none" viewBox="0 0 428 104" xmlns="http://www.w3.org/2000/svg">
    <rect
      fill="url(#paint0_linear_11219_8167)"
      height="94"
      rx="16"
      ry="16"
      width="428"
      y="9.0553"
    />
    <path
      d="M68.722 55.3079C65.1624 55.6044 57.6459 55.9238 54.5127 54.1149C52.4417 52.9194 52.2827 51.0728 54.3723 49.8665C55.4551 49.2414 56.8989 48.8246 59.7864 48.8246C59.7864 47.1577 60.5082 46.3242 61.591 45.6991C63.6806 44.4927 66.8792 44.5845 68.9501 45.7801C72.0833 47.5889 71.5302 51.9283 71.0165 53.9832C70.8436 54.6747 69.9198 55.2081 68.722 55.3079Z"
      fill="#F3565B"
    />
    <path
      d="M61.5137 51.0927C63.6304 49.8865 66.8215 49.9476 68.9707 51.0927H71.6826L71.7109 56.2235C71.7486 57.5635 71.5224 58.8507 71.3018 59.7333C71.1217 60.4533 70.1593 61.0092 68.9121 61.1132C65.2057 61.4219 57.3787 61.7544 54.1162 59.871C53.0089 59.2317 52.4279 58.4132 52.418 57.5985L52.4141 57.5995L52.4482 51.0927H61.5137Z"
      fill="#C24549"
    />
    <path
      d="M61.5137 51.0927C63.6304 49.8865 66.8215 49.9476 68.9707 51.0927H71.6826L71.7109 56.2235C71.7486 57.5635 71.5224 58.8507 71.3018 59.7333C71.1217 60.4533 70.1593 61.0092 68.9121 61.1132C65.2057 61.4219 57.3787 61.7544 54.1162 59.871C53.0089 59.2317 52.4279 58.4132 52.418 57.5985L52.4141 57.5995L52.4482 51.0927H61.5137Z"
      fill="url(#paint1_linear_11219_8167)"
      fill-opacity="0.2"
    />
    <path
      d="M61.2939 44.6309C63.6296 43.2825 67.2048 43.3844 69.5195 44.7207C70.9175 45.5278 71.6571 46.7862 72.0068 48.1523H72.2666V50.0605C72.3159 51.521 72.0693 52.9287 71.8291 53.8896C71.6359 54.6625 70.6033 55.2595 69.2646 55.3711C65.2859 55.7026 56.884 56.0589 53.3818 54.0371C52.2322 53.3734 51.6108 52.5304 51.5615 51.6846H51.5557V49.5957H52.5205V49.7793C52.7228 49.608 52.9568 49.4427 53.2246 49.2881C54.4349 48.5894 56.0489 48.124 59.2764 48.124C59.2764 46.2608 60.0836 45.3296 61.2939 44.6309Z"
      fill="#C24549"
    />
    <path
      d="M69.2643 53.4248C65.2856 53.7563 56.8839 54.1132 53.3817 52.0914C51.0669 50.7551 50.8891 48.6911 53.2248 47.3427C54.4351 46.6439 56.0489 46.1781 59.2764 46.1781C59.2764 44.3149 60.0833 43.3832 61.2936 42.6845C63.6293 41.3361 67.2045 41.4387 69.5193 42.7751C73.0214 44.7969 72.4032 49.6473 71.829 51.9442C71.6358 52.7171 70.6031 53.3133 69.2643 53.4248Z"
      fill="#F3565B"
    />
    <path
      d="M373.6 22.3609C378.924 22.8044 390.164 23.2819 394.85 20.5769C397.947 18.789 398.185 16.0275 395.06 14.2235C393.441 13.2886 391.281 12.6654 386.963 12.6654C386.963 10.1725 385.884 8.92605 384.264 7.99122C381.14 6.18716 376.356 6.32448 373.259 8.1124C368.574 10.8174 369.401 17.3068 370.169 20.3799C370.427 21.4141 371.809 22.2117 373.6 22.3609Z"
      fill="#F3565B"
    />
    <path
      d="M384.379 16.0565C381.214 14.2534 376.443 14.3445 373.229 16.0565H369.172L369.129 23.7587C369.077 25.752 369.414 27.6649 369.743 28.9784C370.012 30.0551 371.451 30.8854 373.316 31.0409C378.859 31.5027 390.564 32 395.443 29.1835C397.098 28.2278 397.967 27.0049 397.982 25.787L397.989 25.788L397.937 16.0565H384.379Z"
      fill="#C24549"
    />
    <path
      d="M384.379 16.0565C381.214 14.2534 376.443 14.3445 373.229 16.0565H369.172L369.129 23.7587C369.077 25.752 369.414 27.6649 369.743 28.9784C370.012 30.0551 371.451 30.8854 373.316 31.0409C378.859 31.5027 390.564 32 395.443 29.1835C397.098 28.2278 397.967 27.0049 397.982 25.787L397.989 25.788L397.937 16.0565H384.379Z"
      fill="url(#paint2_linear_11219_8167)"
      fill-opacity="0.2"
    />
    <path
      d="M384.71 6.39246C381.217 4.37597 375.87 4.52974 372.408 6.5282C370.318 7.73516 369.212 9.61698 368.688 11.66H368.3V14.5126C368.226 16.6972 368.595 18.8028 368.954 20.2401C369.243 21.396 370.788 22.2881 372.79 22.455C378.74 22.9506 391.305 23.4843 396.542 20.4608C398.261 19.4683 399.191 18.2071 399.265 16.9423H399.272V13.8182H397.83V14.0936C397.527 13.8373 397.177 13.5906 396.776 13.3593C394.966 12.3143 392.553 11.6171 387.727 11.6171C387.726 8.83091 386.52 7.43732 384.71 6.39246Z"
      fill="#C24549"
    />
    <path
      d="M372.79 19.545C378.74 20.0407 391.304 20.5745 396.542 17.5509C400.003 15.5524 400.269 12.4658 396.776 10.4493C394.966 9.40438 392.553 8.70776 387.726 8.70776C387.726 5.9213 386.52 4.52807 384.71 3.48315C381.217 1.46666 375.87 1.62015 372.408 3.6186C367.171 6.64216 368.096 13.8957 368.954 17.3307C369.243 18.4866 370.788 19.3782 372.79 19.545Z"
      fill="#F3565B"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11219_8167"
        gradientUnits="userSpaceOnUse"
        x1="214"
        x2="214"
        y1="9.0553"
        y2="103.055"
      >
        <stop stop-color="#FFE3E9" />
        <stop offset="0.379832" stop-color="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_11219_8167"
        gradientUnits="userSpaceOnUse"
        x1="62.0662"
        x2="62.0662"
        y1="54.77"
        y2="58.4527"
      >
        <stop />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_11219_8167"
        gradientUnits="userSpaceOnUse"
        x1="383.554"
        x2="383.554"
        y1="21.5558"
        y2="27.0627"
      >
        <stop />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
